import axios from "axios"

export const createChat = ({ contactsIds }) =>
  axios.post("/api/v1/conversations", {
    recipient_ids: contactsIds
  })

export const chats = (cursor) =>
  axios.get("/api/v1/conversations", {
    params: {
      older_than: cursor
    }
  })

export const chat = (id) => axios.get(`/api/v1/conversations/${id}`)

export const chatWithMembers = ({ membersIds }) =>
  axios.get("/api/v1/conversations", {
    params: {
      contains_member_ids: membersIds
    }
  })

export const messages = ({ conversationId, cursor }) =>
  axios.get(`/api/v1/conversations/${conversationId}/messages`, {
    params: {
      older_than: cursor
    }
  })

export const sendMessage = ({ content, conversationId }) => axios.post(`/api/v1/conversations/${conversationId}/messages`, { content })

export const leaveConversation = (conversationId) => axios.delete(`/api/v1/conversations/${conversationId}/membership`)

export const friendRequests = () =>
  axios.get("/api/v1/friend_requests", {
    params: {
      direction: "incoming",
      per_page: 10,
      state: "pending"
    }
  })

export const markMessageAsRead = ({ id }) => axios.post(`/api/v1/messages/${id}/mark_as_read`)

export const acceptFriendRequest = ({ userId }) => axios.post(`/api/v1/friend_requests/${userId}/accept`)

export const ignoreFriendRequest = ({ userId }) => axios.post(`/api/v1/friend_requests/${userId}/ignore`)

export const sendFriendRequest = ({ userId }) =>
  axios.post("/api/v1/friend_requests", {
    recipient_id: userId
  })

export const cancelFriendRequest = ({ userId }) => axios.delete(`/api/v1/friend_requests/${userId}`)

export const ignoreUserMessages = ({ userId }) => axios.delete(`/api/v1/friendships/${userId}`)

export const unfollowUser = ({ userId }) => axios.delete(`/api/v1/followed_users/${userId}`)

export const blockUser = ({ userId }) => axios.post(`/api/v1/accounts/${userId}/ignore`)

export const unblockUser = ({ userId }) => axios.delete(`/api/v1/accounts/${userId}/ignore`)

export const friends = ({ query, page }) =>
  axios.get("/api/v1/friendships", {
    params: {
      query,
      page
    }
  })
